#out: $1.js, compress:false, sourcemap:true
module = ()->
  $ ->

    $("[name=limit]").on 'change', ()->
      form = $('#purchases_search_form_wrap form')
      replacePage(window.location.pathname + "?limit=#{$(this).val()}&"+form.serialize())

    $(".range").each ()->
      # id = $(this).attr("name")
      # minValue = parseInt($(this).attr("min"))
      # maxValue = parseInt($(this).attr("max"))
      slider = jQuery.data( this, "slider-instance")
      if slider
        slider.updateOptions({
            tooltips: true
        })

      # try
        # slider = noUiSlider.create(
        #   this,
        #   {
        #     start: [minValue, maxValue],
        #     connect: true,
        #     tooltips: true,
        #     range:{
        #       'min':[minValue],
        #       'max':[maxValue]
        #     }
        #   }, true
        # )
        #
        # slider.on 'change', ()->
        #   if slider.get()[0] != 0
        # 	   $("input[name=min#{id}]").val(slider.get()[0])
        #   else
        # 	   $("input[name=min#{id}]").val("")
        #   if slider.get()[1] != 0
        #      $("input[name=max#{id}]").val(slider.get()[1])
        #   else
        #      $("input[name=max#{id}]").val("")
        	# $("input[name=max#{id}]").val(slider.get()[1])
      # catch e
      #   console.log e


    $('#purchases_search_do_form').click ->
      if $(this).hasClass('purchases-search-do-form-active')
        $(this).removeClass 'purchases-search-do-form-active'
        $(this).text 'Поиск'
      else
        $(this).addClass 'purchases-search-do-form-active'
        $(this).text 'Скрыть'
      $('#purchases_search_form_wrap').slideToggle 'fast'
      return

    $('#purchases_search_sum').keyup ->
      val = $(this).val()
      if $(this).val() > 100000
        $(this).val 100000
      $('#purchases_search_sum_slider').slider 'value', val
      return

    window.rerun = ->
      $('.more-purchases').on 'click touchstart touchend', () ->
        if $(this).hasClass('more-purchases-active')
          $(this).removeClass 'more-purchases-active'
          $(this).parent().css 'border-bottom', ''
          $(this).children('a').text 'Подробнее'
        else
          $(this).addClass 'more-purchases-active'
          $(this).parent().css 'border-bottom', '1px solid silver'
          $(this).children('a').text 'Скрыть'
        # $(this).next().slideToggle 'fast'
        return

      $(".pagen-link, .pagen-pre, .pagen-next").click (e)->
        loadNewPage($(this))
        e.preventDefault()


    rerun()
    $("#do_purchases_search").click (e)->
      e.preventDefault()
      form = $('#purchases_search_form_wrap form');
      replacePage(window.location.pathname + "?limit=#{$(".display-options [name=limit]:checked").val()}&" + form.serialize())

    window.replacePage = (href)->
      $.get href + "&embed=1"
        .done (html)->
          $("#ajax-body").replaceWith($.parseHTML(html))
          $('html, body').animate({
              scrollTop: $(".purchase-reglament-titles").offset().top - $("header").height()
          }, 300)
          rerun()

    window.loadNewPage = (link)->
      href = $(link).attr("href")
      replacePage(href)
      return;

  return

unit.define "site::purchases", module, "site::global", "site::share"
